<template>
  <Calendar
    locale="uk-UA"
    dots
    :min-date="new Date(2021, 0)"
    :attributes="calendar"
    @transition-start="monthChange"
    ref="calendar"
  />
</template>

<script>
import { computed } from 'vue';
import { useStore, mapActions } from 'vuex';
import { Calendar } from 'v-calendar';
import { format } from 'date-fns';

export default {
  props: ['rawEvents', 'sortedEvents'],
  setup(props) {
    const store = useStore();

    store.dispatch('eventCalendar/setRawEvents', props.rawEvents);
    store.dispatch('eventCalendar/setSortedEvents', props.sortedEvents);

    return {
      calendar: computed(() => store.getters['eventCalendar/getCalendar']),
    };
  },
  components: {
    Calendar,
  },
  methods: {
    monthChange() {
      let month = this.formatMonth(this.$refs.calendar.lastPage.key);
      this.setCurrentEvents(month);
    },
    formatMonth(month) {
      return format(new Date(month), 'yyyy-MM');
    },
    ...mapActions({
      setCurrentEvents: 'eventCalendar/setCurrentEvents',
    }),
  },
};
</script>

<style>
.vc-title {
  text-transform: capitalize;
}
</style>
